import React from 'react';
import { GridFilterModel as MuixFilterModel, GridLogicOperator as MuixLogicOperator } from '@mui/x-data-grid-pro';
import { GridFilterItem, GridFilterModel, GridFilterOperator, GridLogicOperator } from '@warehouse/object-browser/core';
import { PaginationNavigatorCore, ServerDataGridConfig } from '@warehouse/shared/ui';
import { isServiceLogColumnField, ServiceLogColumnField } from '@warehouse/service-log/core';
import { serviceLogStoreSelector, useServiceLogStore } from '@warehouse/service-log/domain';

type ServiceLogFilterModel = GridFilterModel<ServiceLogColumnField>;
type ServiceLogFilterItem = GridFilterItem<ServiceLogColumnField>;

/**
 * The table-manager store keeps the MUI model, typed on the Service Log columns (an item on an unknown field is
 * dropped); the Broker mapping happens in ServiceLogFilterAdapter.
 */
const FilterAdapter = {
	fromMuiXDataGridToApi(filterModel: MuixFilterModel): ServiceLogFilterModel {
		return {
			logicOperator: filterModel.logicOperator === MuixLogicOperator.Or ? GridLogicOperator.OR : GridLogicOperator.AND,
			items: filterModel.items.flatMap((item): ServiceLogFilterItem[] =>
				isServiceLogColumnField(item.field)
					? [{ ...item, field: item.field, operator: item.operator as GridFilterOperator }]
					: [],
			),
		};
	},
	fromApiToMuiXDataGrid(filterModel: ServiceLogFilterModel): MuixFilterModel {
		return {
			logicOperator: filterModel.logicOperator === GridLogicOperator.OR ? MuixLogicOperator.Or : MuixLogicOperator.And,
			items: filterModel.items.map((item) => ({ ...item })),
		};
	},
};

export function ServiceLogPaginationNavigator() {
	const actions = useServiceLogStore(serviceLogStoreSelector.actions);
	const page = useServiceLogStore(serviceLogStoreSelector.page);
	const totalPages = useServiceLogStore(serviceLogStoreSelector.totalPages);
	const perPage = useServiceLogStore(serviceLogStoreSelector.perPage);

	return <PaginationNavigatorCore centered actions={actions} page={page} totalPages={totalPages} perPage={perPage} />;
}

export const serviceLogGridConfig: ServerDataGridConfig<ServiceLogColumnField> = {
	// The Broker search has no sort parameter: no sorting anywhere in the grid, same as the Logs tab.
	sorting: false,
	filtering: { adapter: FilterAdapter },
	pinning: 'grid',
	reorder: false,
	resizable: true,
	pagination: { placement: 'in-grid', component: ServiceLogPaginationNavigator },
};
